import React from "react";
import Breakpoint from "util/responsive/breakpoint";
export default function PhoneBreakpoint(props) {
  return <Breakpoint name="phone">{props.children}</Breakpoint>;
}
